export default __webpack_public_path__ + "static/media/linkedin.68112f20.svg";